// How old the number on the screen is.
//
// Every realtime leaf carries `updatedAt`: when the ingest wrote it, by our own
// clock. That is the honest answer to "is this current?" — an AEI house that
// stops reporting keeps its last values, and the farm's own timestamp (`recAt`)
// cannot settle it, because it comes from a clock we do not control and the
// exports replay old rows.

// A reading older than this is called out rather than shown as current.
export const STALE_AFTER_MS = 12 * 60 * 60 * 1000

const MINUTE_MS = 60 * 1000
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS

// Below this, "just now" reads better than a count of minutes.
const JUST_NOW_MS = 90 * 1000

export function isStale (updatedAt, now = Date.now()) {
  return typeof updatedAt !== 'number' || (now - updatedAt) > STALE_AFTER_MS
}

/**
 * The age of a reading as a translation key and its count, so the caller
 * renders it with its own language's plural rules.
 *
 * `family` picks the wording: a card says its values were updated, the complex
 * header says when its gateway last uploaded. Both age the same way.
 *
 * Counts are floored: 59 minutes stays 59 rather than rounding up to an hour
 * that has not passed.
 */
export function freshnessLabel (updatedAt, now = Date.now(), family = 'aei.updated') {
  if (typeof updatedAt !== 'number') return null

  const age = Math.max(0, now - updatedAt)
  if (age < JUST_NOW_MS) return { key: `${family}_just_now`, count: 0 }
  if (age < HOUR_MS) return { key: `${family}_minutes`, count: Math.floor(age / MINUTE_MS) }
  if (age < DAY_MS) return { key: `${family}_hours`, count: Math.floor(age / HOUR_MS) }
  return { key: `${family}_days`, count: Math.floor(age / DAY_MS) }
}

/** The farm's own timestamp, as the Integra Viewer exported it. */
export function formatRecordedAt (recAt) {
  return typeof recAt === 'string' && recAt.length >= 16
    ? recAt.slice(0, 16).replace('T', ' ')
    : null
}



// WEBPACK FOOTER //
// ./src/utils/aeiFreshness.js